// configService.js
import ui_config from '../../../data/ui_config.json';
class ConfigService {
  constructor() {
    this.ui_config = ui_config;
  }


  getConfigHeader() {
    return this.ui_config.header;
  }

  getConfigFooter() {
    return this.ui_config.footer;
  }

  getSocialMediaLinks(){
    return this.ui_config.social_media_links;
  }

  // getLogoImageUrl() {
  //   return new URL(`../assets/${this.ui_config.header.logo_image}`, import.meta.url).href
  // }


}


export default new ConfigService();